// if ( typeof PickupAvailabilityCompact !== 'function' ) {

//   class PickupAvailabilityCompact extends HTMLElement {

//     constructor(){

//       super();
//       this.classList.add('active');

//       this.storeSelector = document.querySelector('store-selector[data-main-selector]');
//       if ( this.storeSelector ) {
//         const STORE_CHANGED_EVENT = () => {
//           this.fetchAvailability(this.dataset.variantId, true);
//         }
//         this.storeSelector.addEventListener('storechanged', STORE_CHANGED_EVENT);
// 				const observer = new MutationObserver(()=>{
//           this.storeSelector.removeEventListener('storechanged', STORE_CHANGED_EVENT);
// 					observer.disconnect();
// 				});
// 				observer.observe(this.parentElement, {
// 					attributes: false, childList: true, subtree: false
// 				});
//       }

//       if ( this.hasAttribute('data-static') ) {
//         this.fetchAvailability(this.dataset.variantId);
//       } else {
//         const widgetIntersection = (entries, observer) => {
//           if (!entries[0].isIntersecting) return;
//           observer.unobserve(this);
//           this.fetchAvailability(this.dataset.variantId);
//         }
//         new IntersectionObserver(widgetIntersection.bind(this), {rootMargin: '0px 0px 50px 0px'}).observe(this);
//       }
      
//     }

//     fetchAvailability(variantId, forceFetch = false) {

//       const pickupAvailabilityData = this.querySelector('[data-js-pickup-availability-data]');

//       if ( pickupAvailabilityData && ! forceFetch ) {
//         this.renderPreview(pickupAvailabilityData);
//       } else {

//         const variantSectionUrl = `${this.dataset.baseUrl.endsWith('/')?this.dataset.baseUrl:`${this.dataset.baseUrl}/`}variants/${variantId}/?section_id=helper-pickup-availability-compact`;

//         fetch(variantSectionUrl)
//           .then(response => response.text())
//           .then(text => {
//             const sectionInnerHTML = new DOMParser()
//               .parseFromString(text, 'text/html')
//               .querySelector('.shopify-section');
//             this.renderPreview(sectionInnerHTML);
//           })
//           .catch(e => {
//             console.log(e);
//           });

//       }

//     }
    
//     renderPreview(sectionInnerHTML) {
      
//       const selectedStore = localStorage.getItem('selected-store');

//       if ( this.storeSelector && selectedStore && this.storeSelector.storesList[selectedStore] ) {
//         // search based on selected store 
//         let storeFound = false;
//         if ( selectedStore ) {
//           sectionInnerHTML.querySelectorAll('.pickup-availability-alert').forEach(elm=>{
//             if ( selectedStore == elm.dataset.store ) {
//               this.innerHTML = elm.innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
//               storeFound = true;
//             }
//           })
//         }
//         if ( !storeFound ) {
//           this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-unavailable]').innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
//           storeFound = true;
//         }
//         if ( !selectedStore || !storeFound ) {
//           this.innerHTML = '';
//         }
//       } else {
//         // search based on default store
//         this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-store]').innerHTML;
//       }

//     }
    
//   }

//   if ( typeof customElements.get('pickup-availability-compact') == 'undefined' ) {
//     customElements.define('pickup-availability-compact', PickupAvailabilityCompact);
// 	}

// }












if ( typeof PickupAvailabilityCompact !== 'function' ) {

  class PickupAvailabilityCompact extends HTMLElement {
    
    constructor(){
      super();
      this.classList.add('active');
      const widgetIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.fetchAvailability(this.dataset.variantId);
      }
      new IntersectionObserver(widgetIntersection.bind(this), {rootMargin: '0px 0px 50px 0px'}).observe(this);

      this.storeSelector = document.querySelector('store-selector');
      window.addEventListener('load', ()=>{
        if ( this.storeSelector ) {
          this.storeSelector.addEventListener('storechanged', e=>{
            this.fetchAvailability(this.dataset.variantId);
          })
        }
      })
      
    }

    fetchAvailability(variantId) {
      const variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=helper-pickup-availability-compact`;
      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          console.log(e);
        });

    }
    
    renderPreview(sectionInnerHTML) {
      
      if($(document).find('#itg-product-variants').length){
        var selectedId = $(document).find('input[name="id"]').attr('value');
        $(document).find('[product-shipping-value]').attr('product-shipping-value',selectedId);
      }else if($(document).find('[data-quickview="true"]').length){
        var selectedId = $(this).parents('[data-quickview="true"]').find('input[name="id"]').attr('value');
        $(document).find('[product-shipping-value]').attr('product-shipping-value',selectedId);
      }
      
      const selectedStore = localStorage.getItem('selected-store');

     

      
      if ( this.storeSelector && selectedStore && this.storeSelector.storesList[selectedStore] ) {
        // search based on selected store 
        let storeFound = false;
        let productPageAvailiblity = this.getAttribute('data-product-page');
        let collectionPageAvailiblity = this.getAttribute('data-product-card');
        let collectionPageAvailiblityId = this.getAttribute('data-card-id');
        let checkDrawer = this.getAttribute('data-product-drawer');
        let drawerItemId = this.getAttribute('data-item-id');
        let checkCartPage = this.getAttribute('data-cart-page');
        let cartItemId = this.getAttribute('data-cart-item-id');
        let pickupAvailiblity = 'false';
        var pickupAvalable = $(document).find('#AjaxCartForm').data('pickup-available');
        var pickupUnAvalable = $(document).find('#AjaxCartForm').data('pickup-unavailable');
        let storeName = '';
        if (selectedStore) {
          sectionInnerHTML.querySelectorAll('.pickup-availability-alert').forEach(elm=>{
            if (selectedStore == elm.dataset.store) {
              this.innerHTML = elm.innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
              storeFound = true;
              if(checkDrawer == 'true' || checkCartPage == 'true' || collectionPageAvailiblity == 'true' || productPageAvailiblity == 'true'){
                var checkAvailiblity = $(elm).find('#change-store').attr('data-available');
                storeName = $(elm).find('#change-store').attr('data-store-name');
                pickupAvailiblity = checkAvailiblity;
              }
            }
          })
        }
        var storeText = "Store";
        if(storeName == "Toronto"){
          if(window.location.href.indexOf("/fr") > -1) {
            storeText = "Entrepôt";
          }else{
            storeText = "Warehouse";
          }
        }else{
          if(window.location.href.indexOf("/fr") > -1) {
            storeText = "Magasin";
          }
        }
        /*==============  Update cart drawer ===============*/
        if(checkDrawer == 'true'){
          if(pickupAvailiblity == 'false'){
            $(document).find('div[data-availability-id="'+drawerItemId+'"]').find('span[data-pickup]').removeClass('alert--success alert--note alert--circle-loading').addClass('alert--error pickup-not-available');
          }else if(pickupAvailiblity == 'true'){
            $(document).find('div[data-availability-id="'+drawerItemId+'"]').find('span[data-pickup]').addClass('alert--success').removeClass('alert--note alert--circle-loading alert--error pickup-not-available');
          }
        }else if(checkCartPage == 'true'){
        /*==============  Update cart page ===============*/
          if(pickupAvailiblity == 'false'){
            $(document).find('div[data-availability-id="'+cartItemId+'"]').find('span[data-pickup-availability]').removeClass('alert--success alert--note alert--circle-loading').addClass('alert--error pickup-not-available').text(pickupUnAvalable+' '+storeName+' '+storeText);
            $(document).find('.cart-store-change').show();
          }else if(pickupAvailiblity == 'true'){
            $(document).find('div[data-availability-id="'+cartItemId+'"]').find('span[data-pickup-availability]').addClass('alert--success').removeClass('alert--note alert--circle-loading alert--error pickup-not-available').text(pickupAvalable+' '+storeName+' '+storeText);
            $(document).find('.cart-store-change').show();
          }
        }
        itgDeliveryConflict();
        if ( !storeFound ) {
          this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-unavailable]').innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
          storeFound = true;
        }
        if ( !selectedStore || !storeFound ) {
          this.innerHTML = '';
        }
      } else {
        // search based on default store
        this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-store]').innerHTML;
      }
      if($(document).find('script#itg-shipping-availability').length){
        var deliverySuccess = $(document).find('body').data('delivery-success');
        var deliveryError = $(document).find('body').data('delivery-error');
        var checkFinalArray = $(document).find('script#itg-shipping-availability').html();
        checkFinalArray = JSON.parse(checkFinalArray);
        $(document).find('[data-shipping-id]').each(function(){
          var thisVariantId = $(this).data('shipping-id');
          if($(this).attr('product-shipping-value')){
            thisVariantId = parseInt($(this).attr('product-shipping-value'));
          }
          var thisElement = $(this);
          var thisDrawer = $(this).data('drawer');
          checkFinalArray.forEach(function(variantData) {
            if(thisVariantId == variantData['variant-id']){
              if(variantData['available'] == 'true'){
                if(thisDrawer === true){
                  thisElement.removeClass('alert--circle-loading alert--note alert--error unavailable-delivery').addClass('alert--success');
                }else{
                  thisElement.removeClass('alert--circle-loading alert--note alert--error unavailable-delivery').addClass('alert--success').text(deliverySuccess);
                }
              }else{
               if(thisDrawer === true){
                  thisElement.removeClass('alert--circle-loading alert--note alert--success').addClass('alert--error unavailable-delivery');
               }else{
                  thisElement.removeClass('alert--circle-loading alert--note alert--success').addClass('alert--error unavailable-delivery').text(deliveryError);
               }
              }
            }
          });
        });
      }
      if($(document).find('script#itg-item-shipping-availability').length){
        var checkFinalArray = $(document).find('script#itg-item-shipping-availability').html();
        checkFinalArray = JSON.parse(checkFinalArray);
        $(document).find('.itg-drawer-availability [data-shipping-id]').each(function(){
          var thisVariantId = $(this).data('shipping-id');
          var thisElement = $(this);
          checkFinalArray.forEach(function(variantData) {
            if(thisVariantId == variantData['variant-id']){
              if(variantData['available'] == 'true'){
                thisElement.removeClass('alert--circle-loading alert--note alert--error unavailable-delivery').addClass('alert--success');
              }else{
                thisElement.removeClass('alert--circle-loading alert--note alert--success').addClass('alert--error unavailable-delivery');
              }
            }
          });
        });
      }
      if($(document).find('[data-quickview="true"]').length){
        var checkFinalArray = $(document).find('script#itg-item-shipping-availability').html();
        checkFinalArray = JSON.parse(checkFinalArray);
        var thisVariantId = $(document).find('[data-quickview="true"]').find('[product-shipping-value]').attr('product-shipping-value');
        var thisElement = $(document).find('[data-quickview="true"]').find('[product-shipping-value]');
        checkFinalArray.forEach(function(variantData) {
          if(thisVariantId == variantData['variant-id']){
            if(variantData['available'] == 'true'){
              thisElement.removeClass('alert--circle-loading alert--note alert--error unavailable-delivery').addClass('alert--success').text(deliverySuccess);
            }else{
              thisElement.removeClass('alert--circle-loading alert--note alert--success').addClass('alert--error unavailable-delivery').text(deliveryError);
            }
          }
        });
      }
      var pickText = 'Pickup';
      var selectStore = 'Select store';
      if (window.location.href.indexOf("/fr") > -1) {
         pickText = 'Ramasser';
         selectStore = 'Sélectionnez le magasin';
      }
      if(selectedStore == null || selectedStore == 'null'){
        var thisText = $(document).find('[data-cart-first]').find('span').text();
        $(document).find('[data-pickup-availability]').text(thisText).attr('id','change-store');
        var checkCartDrawer = this.getAttribute('data-product-drawer');
        $(document).find('.itg-drawer-availability').find('[data-pickup]').text(selectStore);
      }else{
        $(document).find('.itg-drawer-availability').find('[data-pickup]').text(pickText);
      }

      // if (selectedStore) {
      //   Rebuy.Sessions.update({
      //     pickup_location: selectedStore
      //   });
      // }
      
    }
  }

  if ( typeof customElements.get('pickup-availability-compact') == 'undefined' ) {
    customElements.define('pickup-availability-compact', PickupAvailabilityCompact);
	}

}

if ( typeof PickupAvailabilityExtended !== 'function' ) {

  class PickupAvailabilityExtended extends HTMLElement {

    constructor() {
      super();
      this.classList.add('active');
      this.fetchAvailability(this.dataset.variantId);
    }


    fetchAvailability(variantId , forceFetch = false) {

      const pickupAvailabilityData = this.querySelector('[data-js-pickup-availability-data]');

      if ( pickupAvailabilityData && ! forceFetch ) {
        this.renderPreview(pickupAvailabilityData);
      } else {

        // const variantSectionUrl = `${this.dataset.baseUrl.endsWith('/')?this.dataset.baseUrl:`${this.dataset.baseUrl}/`}variants/${variantId}/?section_id=helper-pickup-availability-compact`;
       
        const variantSectionUrl = `${this.dataset.baseUrl.endsWith('/')?this.dataset.baseUrl:`${this.dataset.baseUrl}/`}variants/${variantId}/?section_id=helper-pickup-availability-extended`;

        // const variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=helper-pickup-availability-extended`;

        fetch(variantSectionUrl)
          .then(response => response.text())
          .then(text => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(e => {
            console.log(e);
          });

      }
    } 

    renderPreview(sectionInnerHTML) {
      const availabilityWidget = sectionInnerHTML.querySelector('#PickupAvailabilityWidget');
      if ( availabilityWidget ) {
        this.innerHTML = availabilityWidget.innerHTML;
        this.querySelectorAll('.pickup-availability-widget__location-view').forEach(elm=>{
          elm.addEventListener('click', ()=>{
            document.getElementById(`${elm.getAttribute('aria-controls')}`).classList.toggle('opened');
            elm.setAttribute('aria-selected', elm.getAttribute('aria-selected') == "true" ? "false" : "true");
          })
        })
      } else {
        console.log('error in availablity fetch');
      }

      const availabilitySidebar = sectionInnerHTML.querySelector('#PickupAvailabilitySidebar');
      if ( availabilitySidebar ) {
        if ( document.querySelector('sidebar-drawer#site-availability-sidebar') ) {
          document.querySelector('sidebar-drawer#site-availability-sidebar').remove();
        } 
        document.body.appendChild(availabilitySidebar.querySelector('#site-availability-sidebar'));
        document.querySelector('.pickup-availability-widget__more').addEventListener('click', e=>{
          e.preventDefault();
          document.getElementById('site-availability-sidebar').show();
        })
      }

    }

  }

  if ( typeof customElements.get('pickup-availability-extended') == 'undefined' ) {
    customElements.define('pickup-availability-extended', PickupAvailabilityExtended);
	}

}

function itgDeliveryConflict(){
  var checkShip = false;
  var checkpick = false;
  $(document).find('body').removeClass('delivery-conflict');
  $(document).find('.alert-delivery-conflict').remove();
  var myInterval = setInterval(function(){
   if($(document).find('#AjaxCartForm').find('.unavailable-delivery').length && $(document).find('#AjaxCartForm').find('.pickup-not-available').length){
      if($(document).find('#AjaxCartForm').find('.pickup-not-available').length && $(document).find('#AjaxCartForm').find('.unavailable-delivery').length){
        if($(document).find('.alert-delivery-conflict').length){}else{
          $(document).find('#AjaxCartForm').prepend('<div class="alert-delivery-conflict"><strong><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="alert-triangle"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> Delivery conflict detected in your cart:</strong> Your items can be picked up in store or delivered, but not both in one order. You must place two orders.</div>')
          $(document).find('body').addClass('delivery-conflict');
          clearInterval(myInterval);
        }
      }
    }
  },100);
}
itgDeliveryConflict();